import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { ThermicIndexWithApiComponent } from './components/thermic-index-with-api/thermic-index-with-api.component';
import { WindBarbComponent } from './components/wind-barb/wind-barb.component';
import { CloudCoverCircleComponent } from './components/cloud-cover-circle/cloud-cover-circle.component';
import { registerLocaleData } from '@angular/common';
import TRY from '@angular/common/locales/tr';
import { ModalsComponent } from "./components/modals/modals.component";
import { ClipboardModule } from '@angular/cdk/clipboard';
import { WeatherServiceApiService } from './service/weather-service-api.service';
import { HighlightColumnDirective } from './share/directives/highlight-column.directive';
import { BigDataService } from './service/big-data.service';
import { MapComponent } from './components/map/map.component';
import { RadarComponent } from './components/radar/radar.component';
registerLocaleData(TRY);

@NgModule({
    declarations: [
        AppComponent,
        ThermicIndexWithApiComponent,
        WindBarbComponent,
    CloudCoverCircleComponent,
    MapComponent,
    RadarComponent
    ],
    bootstrap: [AppComponent], imports: [ReactiveFormsModule, HighlightColumnDirective,
        BrowserModule,
        AppRoutingModule,
        NoopAnimationsModule,
        NgbModule, ModalsComponent, ClipboardModule,NgbTooltipModule ], providers: [WeatherServiceApiService,BigDataService, DatePipe, { provide: LOCALE_ID, useValue: 'tr-TR' }, provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule { }
